import { Link } from "react-router-dom";
import { ArrowRight, Camera, MessageSquareText, Eye, Store, UtensilsCrossed } from "lucide-react";
import Seo from "@/components/Seo";
import { SichtbarkeitCheck } from "@/components/SichtbarkeitCheck";

const H = { fontFamily: "'Outfit', 'Poppins', sans-serif", fontWeight: 800 };
const B = { fontFamily: "'Poppins', sans-serif" };

/* Akquise-Landingpage für Instagram/TikTok – Handel & Gastro. Hook: Gratis Sichtbarkeits-Check (echtes Tool).
   noindex, damit die bezahlte Landingpage nicht mit /sichtbarkeit um dieselben Keywords konkurriert. */
const SCHRITTE = [
  { icon: Camera, t: "Foto schicken", s: "Ein Teller, ein Schaufenster, ein Angebot – per WhatsApp an Robbie." },
  { icon: MessageSquareText, t: "Robbie bereitet vor", s: "Beitrag, Google-Meldung und Bildschirmmotiv entstehen automatisch." },
  { icon: Eye, t: "Du gibst frei", s: "Vorschau prüfen, antippen – und es ist überall veröffentlicht." },
];

const FUER = [
  { icon: Store, t: "Für den Handel", s: "Neue Ware, Aktionen und Öffnungszeiten landen in einem Schritt bei Google, auf Instagram und im Schaufenster-Bildschirm." },
  { icon: UtensilsCrossed, t: "Für die Gastro", s: "Tageskarte, Event oder Reservierungs-Hinweis – ein Foto genügt, der Rest ist für dich erledigt." },
];

export default function LandingHandelGastroPage() {
  return (
    <div data-testid="aktion-handel-page">
      <Seo noindex title="Gratis Sichtbarkeits-Check für Handel & Gastro | DIMEDIAL"
        description="Sieh in 10 Sekunden, wie gut Google dich findet – kostenlos und ohne Anmeldung. Danach pflegt Robbie Google, Instagram und deine Bildschirme aus einem Foto. 30 Tage gratis testen."
        path="/aktion/handel-gastro" />

      <SichtbarkeitCheck
        utm="aktion-handel"
        kicker="Gratis Check für Handel & Gastro"
        title={<>Finden dich deine Kunden – <span className="bg-[#FDD105] text-[#111] px-2">oder die Konkurrenz?</span></>}
        subtitle="Gib deinen Betrieb ein und sieh in 10 Sekunden, wie gut Google dich zeigt. Kostenlos, ohne Konto. Danach übernimmt Robbie Google, Instagram und deine Bildschirme – aus einem einzigen Foto." />

      <section className="bg-white" data-testid="aktion-handel-schritte">
        <div className="mx-auto max-w-[1100px] px-6 md:px-10 py-16 md:py-20">
          <p style={B} className="text-xs font-bold uppercase tracking-[0.2em] text-[#111]/50">Ein Foto rein. Überall bereit.</p>
          <h2 style={H} className="mt-3 text-[#111] uppercase leading-[1.05] text-3xl md:text-4xl max-w-[20ch]">So einfach bleibst du <span className="bg-[#FDD105] px-2">sichtbar.</span></h2>
          <div className="mt-10 grid gap-5 sm:grid-cols-3">
            {SCHRITTE.map((s, i) => (
              <div key={s.t} className="rounded-3xl border-2 border-[#111] bg-[#F6F4EE] p-6" data-testid={`aktion-handel-schritt-${i}`}>
                <span className="grid h-11 w-11 place-items-center rounded-full bg-[#FDD105]"><s.icon size={20} className="text-[#111]" /></span>
                <h3 style={H} className="mt-4 text-lg uppercase leading-tight text-[#111]">{s.t}</h3>
                <p style={B} className="mt-2 text-sm text-[#4A4A4A] leading-relaxed">{s.s}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 grid gap-5 sm:grid-cols-2">
            {FUER.map((f) => (
              <div key={f.t} className="flex gap-4 rounded-2xl bg-[#111] text-white p-6" data-testid={`aktion-handel-fuer-${f.t.includes("Handel") ? "handel" : "gastro"}`}>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#FDD105]"><f.icon size={20} className="text-[#111]" /></span>
                <div><h3 style={H} className="text-lg uppercase leading-tight">{f.t}</h3><p style={B} className="mt-1.5 text-sm text-white/70 leading-relaxed">{f.s}</p></div>
              </div>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/kunden/registrieren?utm_source=aktion-handel&utm_medium=landing&pwless=1" className="inline-flex items-center gap-2 rounded-full bg-[#FDD105] px-7 py-4 text-sm font-bold uppercase tracking-wider text-[#111] transition-transform hover:-translate-y-0.5" data-testid="aktion-handel-cta">30 Tage kostenlos testen <ArrowRight size={16} /></Link>
            <span style={B} className="text-xs text-[#5C574F]">Ohne Zahlungsdaten · monatlich kündbar · ab 59 € netto/Monat · <Link to="/preise" className="underline font-semibold text-[#111]" data-testid="aktion-handel-preise">Alle Preise</Link></span>
          </div>
        </div>
      </section>
    </div>
  );
}
